import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BreadcrumbsComponent {
  @Input() path: { url: string, name: string }[];

}
